import './AddLinkModal.css';

import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { Button, Grid, TextField, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AppLoader from 'components/Loader';
import Modal from 'components/ModalWrapper';
import { TrackLinkAdd } from 'utilities/insights';
import { addLink } from 'redux/thunks/dashboard';
import { resetAddingLink } from 'redux/actions/dashboard';
import { sortAndRemoveDuplicateStringValues } from 'utilities/arraySort';
import { v4 as uuid } from 'uuid';
import { validURL } from 'utilities/Validations';

const AddLinkModal = (props) => {
    const categories = useSelector((state) => state.site.categories);

    const { siteId, dashboardId, linkCategories, onClose, show } = props;

    const [category, set_category] = useState('');
    const [URL, set_URL] = useState('');
    const [description, set_description] = useState('');
    const [fieldErrors, setFieldErrors] = useState({});
    const dispatch = useDispatch();
    const addingLink = useSelector((state) => state.dashboard.addingLink);
    const addingLinkSuccess = useSelector((state) => state.dashboard.addingLinkSuccess);
    const filter = createFilterOptions();

    useEffect(() => {
        if (show && addingLinkSuccess) {
            resetAll();
            onClose();
            dispatch(resetAddingLink());
        }
    }, [addingLinkSuccess, show, dispatch, onClose]);

    const handleSubmit = async () => {
        let linkToAdd = {
            siteId,
            dashboardId,
            linkId: uuid(),
            category,
            description,
            URL,
        };

        if (!validate()) {
            return;
        }

        TrackLinkAdd(siteId, dashboardId, category);
        dispatch(addLink(linkToAdd));
    };

    const resetAll = () => {
        set_URL('');
        set_description('');
        set_category('');
    };

    const validate = () => {
        let errors = {};

        if (!URL) {
            errors['url'] = 'This field is required';
        } else {
            const validUrl = validURL(URL);

            if (!validUrl) {
                errors['url'] = 'Please enter a valid url';
            }
        }

        if (!description) {
            errors['description'] = '';
        }

        if (!category) {
            errors['category'] = '';
        }

        setFieldErrors(errors);
        return Object.keys(errors).length === 0;
    };

    return (
        <div>
            <Modal height='small' open={show} onCloseClicked={onClose}>
                <Grid container className='add-link-modal'>
                    <Grid container item justifyContent='center' className='add-link-modal__title'>
                        <Typography variant='h5'>Add a Link</Typography>
                    </Grid>

                    <Grid container direction='column' className='add-link-modal__body'>
                        {addingLink ? (
                            <AppLoader />
                        ) : (
                            <>
                                <TextField
                                    error={'url' in fieldErrors}
                                    helperText={'url' in fieldErrors && fieldErrors['url']}
                                    variant='outlined'
                                    label='Url *'
                                    placeholder='Enter your new link here...'
                                    value={URL}
                                    onChange={(e) => set_URL(e.target.value)}
                                    className='add-link-modal__form-field'
                                />
                                <TextField
                                    error={'description' in fieldErrors}
                                    helperText={'description' in fieldErrors && 'This field is required'}
                                    className='add-link-modal__form-field'
                                    variant='outlined'
                                    label='Description *'
                                    placeholder='Write a short description...'
                                    value={description}
                                    onChange={(e) => set_description(e.target.value)}
                                    maxLength='100'
                                />
                                <Autocomplete
                                    id='category-dropdown'
                                    freeSolo
                                    className='add-link-modal__form-field'
                                    value={category}
                                    filterOptions={(options, params) => {
                                        const filtered = filter(options, params);

                                        // Suggest the creation of a new value
                                        if (params.inputValue !== '') {
                                            filtered.push(params.inputValue);
                                            set_category(params.inputValue);
                                        }
                                        return filtered;
                                    }}
                                    selectOnFocus
                                    options={sortAndRemoveDuplicateStringValues([...categories, ...linkCategories])}
                                    getOptionLabel={(option) => {
                                        // Value selected from options
                                        if (typeof option === 'string') {
                                            return option;
                                        }
                                        // Add "xxx" option created dynamically
                                        if (option.inputValue) {
                                            return option.inputValue;
                                        }
                                        // Regular option
                                        return option;
                                    }}
                                    onInputChange={(event, value, reason) => {
                                        set_category(value);
                                    }}
                                    renderOption={(option) => {
                                        return option;
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label='Category *'
                                            placeholder='Add a category or select an existing one...'
                                            variant='outlined'
                                        />
                                    )}
                                />
                            </>
                        )}
                    </Grid>
                    <Grid container justifyContent='space-between' className='add-link-modal__footer'>
                        <Button color='default' size='large' variant='contained' onClick={props.onClose} className='add-link-modal__footer-button--close'>
                            Close
                        </Button>
                        <Button
                            color='primary'
                            size='large'
                            variant='contained'
                            disabled={addingLink}
                            onClick={() => {
                                handleSubmit();
                            }}
                            className='add-link-modal__footer-button--save'
                        >
                            Save Changes
                        </Button>
                    </Grid>
                </Grid>
            </Modal>
        </div>
    );
};

export default AddLinkModal;
